<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CuW7DY/tc-custom/9780062046086.jpg?1732245287116" alt="This image is the cover for the book Luck"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Luck
      </h1>
      <p class="bookDescription body article font2">
        <p>Filled with everything you need to live a luckier life, <i>Luck: The Essential Guide</i> is here with information, advice, or if you just have to knock on wood.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Aaronson, Kevin Kwan
      </h2>
      
      <p class="authorDescription body article"><P>Deborah Aaronson is currently executive editor at Harry N. Abrams. She lives in New York.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f373aea